import { Pagination } from "react-bootstrap";

const PaginationComponent = ({
  page,
  setPage,
  size,
  setSize,
  totalPages,
}) => {
  return (
    <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-4 gap-3">

      {/* Page Size */}
      <div className="d-flex align-items-center gap-2">
        <span className="fw-semibold" style={{ color: "#e07b39" }}>
          Page Size:
        </span>

        <select
          value={size}
          onChange={(e) => {
            setPage(0);
            setSize(Number(e.target.value));
          }}
          className="form-select form-select-sm w-auto"
          style={{
            borderColor: "#e07b39",
            color: "#e07b39",
            fontWeight: 600,
          }}
        >
          <option value={5}>5</option>
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={50}>50</option>
        </select>
      </div>

      {/* Pagination Controls */}
      <Pagination className="mb-0">

        <Pagination.First
          disabled={page === 0}
          onClick={() => setPage(0)}
        />

        <Pagination.Prev
          disabled={page === 0}
          onClick={() => setPage(page - 1)}
        />

        {[...Array(totalPages)].map((_, i) => (
          <Pagination.Item
            key={i}
            active={i === page}
            onClick={() => setPage(i)}
            style={{
              backgroundColor: i === page ? "#e07b39" : "#fff",
              borderColor: "#e07b39",
              color: i === page ? "#fff" : "#e07b39",
              fontWeight: 600,
            }}
          >
            {i + 1}
          </Pagination.Item>
        ))}

        <Pagination.Next
          disabled={page === totalPages - 1}
          onClick={() => setPage(page + 1)}
        />

        <Pagination.Last
          disabled={page === totalPages - 1}
          onClick={() => setPage(totalPages - 1)}
        />

      </Pagination>
    </div>
  );
};

export default PaginationComponent;